import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  GET_CREDENTIALSNT,
  CREATE_CREDENTIALSNT,
  UPDATE_CREDENTIALSNT,
  DELETE_CREDENTIALSNT,
  GET_CREDENTIALSNT_STATES,
  GET_CREDENTIALSNT_SPECIALTIES,
} from './actionType';

import {
  CredentialsNTApiResponseSuccess,
  CredentialsNTApiResponseError,
} from './action';

import {
  getCredentialsNT as getCredentialNT,
  createCredentialsNT as createCredentialNT,
  updateCredentialsNT as updateCredentialNT,
  deleteCredentialsNT as deleteCredentialNT,
  getCredentialsNTStates as getCredentialNTStates,
  getCredentialsNTSpecialties as getCredentialNTSpecialties,
} from '../../helpers/backend_helper';
import { notifyError, notifySuccess } from '../../components/notify';

function* getCredentialsNT(data) {
  try {
    const response = yield call(getCredentialNT, data.payload);
    yield put(CredentialsNTApiResponseSuccess(GET_CREDENTIALSNT, response));
  } catch (error) {
    yield put(CredentialsNTApiResponseError(GET_CREDENTIALSNT, error));
  }
}

function* createCredentialsNT(data) {
  try {
    const response = yield call(createCredentialNT, data.payload);
    yield put(CredentialsNTApiResponseSuccess(CREATE_CREDENTIALSNT, response));
    notifySuccess('Credencial criada com sucesso!');
  } catch (error) {
    yield put(CredentialsNTApiResponseError(CREATE_CREDENTIALSNT, error));
    notifyError('Erro ao criar credencial!');
  }
}

function* updateCredentialsNT(data) {
  try {
    const response = yield call(updateCredentialNT, data.payload.data);
    yield put(CredentialsNTApiResponseSuccess(UPDATE_CREDENTIALSNT, response));
    notifySuccess('Credencial atualizada com sucesso!');
  } catch (error) {
    yield put(CredentialsNTApiResponseError(UPDATE_CREDENTIALSNT, error));
    notifyError('Erro ao atualizar credencial!');
  }
}

function* deleteCredentialsNT(data) {
  try {
    const response = yield call(deleteCredentialNT, data.payload.id);
    yield put(CredentialsNTApiResponseSuccess(DELETE_CREDENTIALSNT, response));
    notifySuccess('Credencial deletada com sucesso!');
  } catch (error) {
    yield put(CredentialsNTApiResponseError(DELETE_CREDENTIALSNT, error));
    notifyError('Erro ao deletar credencial!');
  }
}

function* getCredentialsNTStates() {
  try {
    const response = yield call(getCredentialNTStates);
    yield put(
      CredentialsNTApiResponseSuccess(GET_CREDENTIALSNT_STATES, response)
    );
  } catch (error) {
    yield put(CredentialsNTApiResponseError(GET_CREDENTIALSNT_STATES, error));
  }
}

function* getCredentialsNTSpecialties(data) {
  try {
    const response = yield call(
      getCredentialNTSpecialties,
      data.payload.params
    );
    yield put(
      CredentialsNTApiResponseSuccess(GET_CREDENTIALSNT_SPECIALTIES, response)
    );
  } catch (error) {
    yield put(
      CredentialsNTApiResponseError(GET_CREDENTIALSNT_SPECIALTIES, error)
    );
  }
}

export function* watchGetCredentialsNT() {
  yield takeEvery(GET_CREDENTIALSNT, getCredentialsNT);
}

export function* watchCreateCredentialsNT() {
  yield takeEvery(CREATE_CREDENTIALSNT, createCredentialsNT);
}

export function* watchUpdateCredentialsNT() {
  yield takeEvery(UPDATE_CREDENTIALSNT, updateCredentialsNT);
}

export function* watchDeleteCredentialsNT() {
  yield takeEvery(DELETE_CREDENTIALSNT, deleteCredentialsNT);
}

export function* watchGetCredentialsNTStates() {
  yield takeEvery(GET_CREDENTIALSNT_STATES, getCredentialsNTStates);
}

export function* watchGetCredentialsNTSpecialties() {
  yield takeEvery(GET_CREDENTIALSNT_SPECIALTIES, getCredentialsNTSpecialties);
}

function* CredentialsNTSaga() {
  yield all([fork(watchGetCredentialsNT)]);
  yield all([fork(watchCreateCredentialsNT)]);
  yield all([fork(watchUpdateCredentialsNT)]);
  yield all([fork(watchDeleteCredentialsNT)]);
  yield all([fork(watchGetCredentialsNTStates)]);
  yield all([fork(watchGetCredentialsNTSpecialties)]);
}

export default CredentialsNTSaga;
